enum DemographicCategory {
  Gender = 'GENDER',
  Age = 'AGE',
}

export default DemographicCategory;
